// frontend/src/components/Header.tsx
import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

interface HeaderProps {
  toggleSidebar?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ toggleSidebar }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const getInitials = (email: string) => {
    return email.substring(0, 2).toUpperCase();
  };

  // Obtener título basado en la ruta actual
  const getPageTitle = () => {
    const path = location.pathname;
    switch (path) {
      case '/':
      case '/dashboard':
        return 'Dashboard';
      case '/ventas':
        return 'Nota de Venta';
      case '/inventario':
        return 'Inventario';
      case '/almacenes':
        return 'Almacenes';
      case '/proveedores':
        return 'Proveedores';
      case '/tickets':
      case '/costuras':
        return 'Costuras';
      case '/pagos':
        return 'Pagos';
      case '/usuarios':
        return 'Usuarios';
      case '/productos':
        return 'Productos';
      case '/pre-orders':
        return 'Pre-orders';
      case '/compras':
        return 'Compras';
      case '/calendar':
        return 'Calendario';
      case '/clientes':
        return 'Clientes';
      case '/reportes':
        return 'Reportes';
      case '/stores':
        return 'Tiendas y Sucursales';
      default:
        return 'Dashboard';
    }
  };

  return (
    <header className="bg-white border-b border-gray-200 px-8 py-4">
      <div className="flex items-center justify-between">
        {/* Page Title & Toggle */}
        <div className="flex items-center space-x-4">
          {toggleSidebar && (
            <button
              onClick={toggleSidebar}
              className="p-2 rounded-md hover:bg-gray-100 text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 hidden lg:block"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          )}
          <h1 className="text-2xl font-bold text-gray-800">{getPageTitle()}</h1>
        </div>

        {/* User Menu */}
        <div className="flex items-center space-x-4">
          {/* User Info */}
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white font-semibold">
              {user?.email ? getInitials(user.email) : 'AD'}
            </div>
            <div className="text-right">
              <p className="text-sm font-medium text-gray-700">
                {user?.rol_usr || 'Usuario'}
              </p>
              <p className="text-xs text-gray-500">{user?.username || user?.email || ''}</p>
            </div>
          </div>

          {/* Logout Button */}
          <button
            onClick={handleLogout}
            className="flex items-center space-x-2 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            <span className="text-sm font-medium">Cerrar Sesión</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
